var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/sns/circle_apple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 20.2142,
    r: 18.3333,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 20.2142,
    r: 18.0833,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5877 20.0574C25.5644 17.3159 27.7029 15.9997 27.7973 15.9387C26.5956 14.0761 24.722 13.8165 24.0574 13.7853C22.4621 13.6153 20.944 14.7809 20.1372 14.7809C19.3303 14.7809 18.0796 13.8139 16.7602 13.8411C15.019 13.8658 13.42 14.912 12.5237 16.554C10.7187 19.8692 12.0602 24.7835 13.8222 27.4717C14.6806 28.7879 15.7044 30.2663 17.0496 30.2131C18.3482 30.1599 18.8386 29.3266 20.4057 29.3266C21.9728 29.3266 22.413 30.2131 23.7852 30.1911C25.1794 30.1599 26.0635 28.8437 26.9144 27.5275C27.9003 25.9997 28.3099 24.5213 28.3332 24.4434C28.3025 24.4317 25.6134 23.3388 25.5865 20.0574H25.5877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0093 12.0058C23.7254 11.0907 24.2073 9.81602 24.0748 8.54785C23.0461 8.58939 21.799 9.27604 21.062 10.1873C20.3987 11.0011 19.8162 12.3017 19.9744 13.5427C21.1209 13.6348 22.2968 12.9235 23.0093 12.0058Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAppleIcon);
export default __webpack_public_path__ + "static/media/login_apple_icon.ac0335486132cbb909ff8165f71b1c9c.svg";
export { ForwardRef as ReactComponent };